import { BullhornNamespace, InveniasNamespace, SalesforceNamespace } from 'datasource-service-lib';
import { InveniasMockNamespace } from 'datasource-service-lib';
import { SharedServiceProviderServiceFactory } from 'shared-service-provider-lib';
import { BullhornFileListViewConfig } from '../services/bullhorn/bullhorn.filelistviewconfig';
import { InveniasFileListViewConfig, InveniasMockFileListViewConfig } from '../services/invenias/invenias.filelistviewconfig';
import { SalesforceFileListViewConfig } from '../services/salesforce/salesforce.filelistviewconfig';
import { ServiceProviderService } from '../services/service.provider.service';
import { IFileListViewConfig } from './file-list-view.component';

export class FileListViewConfigFactory {
  static create(
    namespace: string,
    serviceProviderService: ServiceProviderService,
    sharedServiceProviderServiceFactory: SharedServiceProviderServiceFactory
  ): IFileListViewConfig {
    if (namespace === InveniasNamespace.name) {
      return new InveniasFileListViewConfig(serviceProviderService, sharedServiceProviderServiceFactory);
    }

    if (namespace === InveniasMockNamespace.name) {
      return new InveniasMockFileListViewConfig(serviceProviderService, sharedServiceProviderServiceFactory);
    }

    if (namespace === BullhornNamespace.name) {
      return new BullhornFileListViewConfig(serviceProviderService, sharedServiceProviderServiceFactory);
    }

    if (namespace === SalesforceNamespace.name) {
      return new SalesforceFileListViewConfig(serviceProviderService, sharedServiceProviderServiceFactory);
    }

    throw new Error(`Cannot find config for namespace '${namespace}'.`);
  }
}
